import React, {useEffect, useState} from "react";
import {PieChart} from '@mui/x-charts/PieChart';
import {Box, CircularProgress, Typography} from "@mui/material";
import {useGlobalContext} from "../context/GlobalState";
import {useNavigate} from "react-router-dom";

export default function DepositsPieChart() {
    const {dashData, setTabStatus} = useGlobalContext();
    const [chartData, setChartData] = useState([]);
    const [remainingBranches, setRemainingBranches] = useState([]);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(!chartData);
    }, [chartData]);

    function handleItemClick(item) {
        let urlParams;
        const branch = item.label;
        if (branch !== "No Data" && branch !== "Other") {
            urlParams = new URLSearchParams({
                field: "branch",
                operator: "is",
                value: branch
            });
        } else if (branch === "Other") {
            urlParams = new URLSearchParams({
                field: "branch",
                operator: "is any of",
                value: remainingBranches.map(branch => branch.label).join(",")
            });

        }
        setTabStatus("All");
        navigate(`/deposit-review?${urlParams}`);
    }

    useEffect(() => {
        let data = dashData?.reduce((acc, check) => {
            const existingBranch = acc.find(item => item.label === check.branchName);
            if (existingBranch) {
                existingBranch.value += check.depositCount;
            } else {
                acc.push({label: check.branchName, value: check.depositCount});
            }
            return acc ?? [];
        }, []);

        // If there are more than 5 branches, combine the rest into "Other"
        if (data?.length > 5) {
            data.sort((a, b) => b.value - a.value);
            const others = data.slice(5).reduce((acc, item) => acc + item.value, 0);
            setRemainingBranches(data.slice(5));
            data = data.slice(0, 5);
            data.push({label: "Other", value: others});
        }

        setChartData(data);
    }, [dashData]);

    return (
        <Box
            sx={{
                background: "white",
                borderRadius: 1,
                padding: 1,
                height: "100%",
                boxSizing: "border-box",
                boxShadow: "3",
                backgroundColor: "primary.componentbg",
            }}
        >
            <Typography variant="h5" style={{textAlign: "left"}}>
                Deposits by Branch
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "calc(100% - 32px)",
                    width: "100%",
                    boxSizing: "border-box",
                    position: "relative"
                }}
            >
                {loading && (
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "primary.componentbg",
                            opacity: 0.7,
                            zIndex: 1
                        }}
                    >
                        <CircularProgress/>
                    </Box>
                )}
                <PieChart
                    colors={chartData?.length ? ["#1C4481", "#811C44", "#44811C", "#81441C", "#1C8144", "#441C81", "#1C8141"] : ["#d3d3d3"]}
                    series={[
                        {
                            data: chartData?.length ? chartData : [{label: "No Data", value: 1}],
                            highlightScope: {fade: 'global', highlight: 'item'},
                            faded: {innerRadius: 30, additionalRadius: -30, color: 'gray'},
                            innerRadius: 30,
                            outerRadius: 100,
                            paddingAngle: 1,
                            cornerRadius: 2,
                            startAngle: 0,
                            endAngle: 360,
                        },
                    ]}
                    onItemClick={(event, pieItemIdentifier, item) => handleItemClick(item)}
                    height={200}
                />
            </Box>
        </Box>
    );
}